import { render } from "./ExpenseCategoryPage.vue?vue&type=template&id=61a61a74&scoped=true&ts=true"
import script from "./ExpenseCategoryPage.vue?vue&type=script&lang=ts"
export * from "./ExpenseCategoryPage.vue?vue&type=script&lang=ts"

import "./ExpenseCategoryPage.vue?vue&type=style&index=0&id=61a61a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a61a74"]])

export default __exports__